document.addEventListener('wpcf7mailsent', function(e) {
    showToast('Ďakujeme, váš dopyt bol úspešne odoslaný.')
}, false)

document.addEventListener('wpcf7mailfailed', function(e) {
    showToast('Pri odosielaní formulára nastala chyba, skúste to znova, prosím.', 'error')
}, false)

// odber noviniek – zatiaľ bez napojenia na mailingovú službu, len potvrdenie
$(document).on('submit', '.newsletter--form', function(e) {
    e.preventDefault()
    this.reset()
    showToast('Ďakujeme, prihlásili ste sa na odber noviniek.')
})

function showToast(message, type = 'success') {
    const toast = $(`<div class="toast toast--${type}">${message}</div>`)
    
    $("body").append(toast)
    
    setTimeout(() => toast.addClass("toast--visible"), 100)
    
    setTimeout(() => {
        toast.removeClass("toast--visible")
        setTimeout(() => toast.remove(), 300)
    }, 3000)
}